import React from "react";
import { INSURANCE_RELATED_PARTNERS } from "../../config/insurance-related-partners";

export const InsuranceRelatedPartners = () => {
    return (
        <div className="irp-page">
            <div className="irp-container">
                <header className="irp-header" role="banner">
                    <h1 className="irp-header-title">Insurance-Related Partners</h1>
                </header>

                <div className="irp-content">
                    <div className="irp-print-link">
                        <a href="#" onClick={(e) => { e.preventDefault(); window.print(); }}>
                            Print this page
                        </a>
                    </div>

                    <p className="irp-intro">
                        GEICO Insurance Agency, LLC works with the following insurance-related partners
                        in connection with commercial insurance quotes.
                    </p>

                    <ul className="irp-list">
                        {INSURANCE_RELATED_PARTNERS.map((name) => (
                            <li key={name}>{name}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
